(() => {
  const VariantSelects = customElements.get('variant-selects');
  if (!VariantSelects) return;
  if (VariantSelects.__kkTogglePatched) return;
  VariantSelects.__kkTogglePatched = true;

  const original = VariantSelects.prototype.toggleAddButton;
  if (typeof original !== 'function') return;

  VariantSelects.prototype.toggleAddButton = function (disabled = true, text, allowUnavailable = true) {
    const form = document.getElementById(`product-form-${this.dataset.section}`);
    if (form) {
      const button = form.querySelector('[name="add"]');
      if (button && !button.querySelector(':scope > span')) {
        const span = document.createElement('span');
        button.insertBefore(span, button.firstChild);
      }
    }

    try {
      return original.call(this, disabled, text, allowUnavailable);
    } catch (e) {
      const formFallback = document.getElementById(`product-form-${this.dataset.section}`);
      const buttonFallback = formFallback?.querySelector('[name="add"]');
      const spanFallback = formFallback?.querySelector('[name="add"] > span');
      if (!buttonFallback) return;

      if (disabled) {
        buttonFallback.setAttribute('disabled', 'disabled');
        if (text && spanFallback) spanFallback.textContent = text;
      } else {
        buttonFallback.removeAttribute('disabled');
        if (spanFallback && window.variantStrings?.addToCart) spanFallback.textContent = window.variantStrings.addToCart;
      }
      if (!allowUnavailable) return;
    }
  };
})();

if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.variantPicker = this.querySelector('variant-radios, variant-selects');
      this.submitButton = this.querySelector('[type="submit"]');
      this.quantityForm = this.querySelector('.product-form__quantity');
    }

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      if (this.input && this.quantityForm) {
        this.setQuantityBoundries();
      }
      this.syncButtonStateFromCurrentVariant();

      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        const data = payload?.data ? payload.data : payload;
        if (!data) return;

        const sectionIdFromEvent = data.sectionId || data.section_id;
        if (sectionIdFromEvent !== sectionId) return;

        let html = data.html;
        if (typeof html === 'string') {
          html = new DOMParser().parseFromString(html, 'text/html');
        }
        if (!html) return;

        const domSectionId = this.dataset.section;
        const variantId = this.getVariantIdFromHtml(html, sectionId) || this.currentVariant?.value;
        if (variantId) this.updateVariantInputs(variantId);
        if (variantId) this.updateFromHtml(html, sectionId, domSectionId, variantId);
        const variant = data.variant || (variantId ? this.getVariantById(variantId) : null);
        if (variant) {
          this.applyVariantPricing(variant, domSectionId);
          this.applyVariantButtonState(variant, domSectionId);
        }
        this.updateQuantityRules(sectionIdFromEvent, html);
        this.setQuantityBoundries();
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    setQuantityBoundries() {
      if (!this.input) return;
      const data = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      }

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.input.min = min;
      this.input.max = max;
      this.input.value = min;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);  
    }

    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) return;
      if (!this.querySelector('.quantity__rules-cart .loading-overlay')) return;
      this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
      fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((response) => {
        return response.text()
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateQuantityRules(this.dataset.section, html);
        this.setQuantityBoundries();
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
      });
    }

    updateQuantityRules(sectionId, html) {
      if (!this.quantityForm) return;
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      if (!quantityFormUpdated) return;
      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) { 
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }

    updateVariantInputs(variantId) {
      this.querySelectorAll('form input[name="id"]').forEach((input) => {
        input.disabled = false;
        input.value = variantId;
        if (input.dataset && input.dataset.selectedId !== undefined) {
          input.dataset.selectedId = `${variantId}`;
        }
      });

      this.currentVariant = this.querySelector('.product-variant-id');
    }

    getVariantById(variantId) {
      if (!this.variantPicker) return null;
      const variantJsonScript = this.variantPicker.querySelector('script[type="application/json"]');
      if (!variantJsonScript) return null;

      let variants;
      try {
        variants = JSON.parse(variantJsonScript.textContent);
      } catch {
        return null;
      }
      if (!Array.isArray(variants)) return null;
      return variants.find((variant) => `${variant.id}` === `${variantId}`) || null;
    }

    formatMoney(amount) {
      const currency = window.Shopify?.currency?.active || 'BRL';
      try {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format(amount);
      } catch {
        return `R$ ${amount.toFixed(2)}`.replace('.', ',');
      }
    }

    applyVariantPricing(variant, domSectionId) {
      const container =
        this.querySelector(`#price-${domSectionId}`) ||
        this.querySelector('.product-page-price') ||
        this.querySelector('.price');
      if (!container) return;

      const priceRoot = container.matches('.price') ? container : container.querySelector('.price') || container;
      const isOnSale = typeof variant.compare_at_price === 'number' && variant.compare_at_price > variant.price;
      const priceAmount = (variant.price || 0) / 100;
      const compareAmount = (variant.compare_at_price || 0) / 100;

      priceRoot.classList.toggle('price--sold-out', !variant.available);
      priceRoot.classList.toggle('price--on-sale', isOnSale);

      const salePriceEl = priceRoot.querySelector('.price__sale .price-item--sale.price-item--last');
      const comparePriceEl = priceRoot.querySelector('.price__compare-price .price-item--regular') || priceRoot.querySelector('.price__compare-price s.price-item--regular');
      const regularPriceEl = priceRoot.querySelector('.price__regular .price-item--regular');

      if (salePriceEl) salePriceEl.textContent = this.formatMoney(priceAmount);
      if (comparePriceEl && isOnSale) comparePriceEl.textContent = this.formatMoney(compareAmount);
      if (regularPriceEl && !isOnSale) regularPriceEl.textContent = this.formatMoney(priceAmount);

    //   const installmentMain = priceRoot.querySelector('.parcelatorProduct p');
    //   if (installmentMain) {
    //     const svg = installmentMain.querySelector('svg');
    //     const text = `1x de ${this.formatMoney(priceAmount)} sem juros`;
    //     installmentMain.innerHTML = svg ? `${svg.outerHTML} ${text}` : text;
    //   }

    //   const installment12 = priceRoot.querySelector('.parcelator2 p');
    //   if (installment12) {
    //     const installmentAmount = (priceAmount * 1.24) / 12;
    //     installment12.textContent = `ou em 12x de ${this.formatMoney(installmentAmount)}`;
    //   }
    }

    applyVariantButtonState(variant, domSectionId) {
      const form = this.querySelector(`#product-form-${domSectionId}`);
      if (!form) return;

      const button = form.querySelector('[name="add"]');
      const label = button?.querySelector(':scope > span');
      if (!button) return;

      if (variant.available) {
        button.removeAttribute('disabled');
        if (label && window.variantStrings?.addToCart) label.textContent = window.variantStrings.addToCart;
      } else {
        button.setAttribute('disabled', 'disabled');
        if (label && window.variantStrings?.soldOut) label.textContent = window.variantStrings.soldOut;
      }
    }

    syncButtonStateFromCurrentVariant() {
      const variantId = this.currentVariant?.value;
      if (!variantId) return;
      if (!this.variantPicker) return;
      const variant = this.getVariantById(variantId);
      if (!variant) return;

      const sectionId = this.dataset.section;
      this.applyVariantPricing(variant, sectionId);
      this.applyVariantButtonState(variant, sectionId);
    }

    getVariantIdFromHtml(html, sectionId) {
      const productInfo = html.getElementById(`ProductInfo-${sectionId}`);
      if (!productInfo) return null;
      const input = productInfo.querySelector('input[name="id"]');
      return input?.value || null;
    }

    updateFromHtml(html, originalSectionId, domSectionId, variantId) {
      const price = this.querySelector(`#price-${domSectionId}`);
      const priceUpdated = html.getElementById(`price-${originalSectionId}`);
      if (price && priceUpdated) price.innerHTML = priceUpdated.innerHTML;

      const stickyAtcPrice = this.querySelector(`#atc-price-${domSectionId}`);
      const stickyAtcPriceUpdated = html.getElementById(`atc-price-${originalSectionId}`);
      if (stickyAtcPrice && stickyAtcPriceUpdated) stickyAtcPrice.innerHTML = stickyAtcPriceUpdated.innerHTML;

      const sku = this.querySelector(`#Sku-${domSectionId}`);
      const skuUpdated = html.getElementById(`Sku-${originalSectionId}`);
      if (sku && skuUpdated) sku.innerHTML = skuUpdated.innerHTML;

      const inventory = this.querySelector(`#Inventory-${domSectionId}`);
      const inventoryUpdated = html.getElementById(`Inventory-${originalSectionId}`);
      if (inventory && inventoryUpdated) {
        inventory.outerHTML = inventoryUpdated.outerHTML.replaceAll(originalSectionId, domSectionId);
      }

      const installmentInput = this.querySelector(`#product-form-installment-${domSectionId} input[name="id"]`);
      if (installmentInput) installmentInput.value = variantId;

      const submitButton = this.querySelector(`#ProductSubmitButton-${domSectionId}`);
      const submitButtonUpdated = html.getElementById(`ProductSubmitButton-${originalSectionId}`);
      if (submitButton && submitButtonUpdated) {
        if (submitButtonUpdated.hasAttribute('disabled')) submitButton.setAttribute('disabled', '');
        else submitButton.removeAttribute('disabled');

        submitButton.removeAttribute('aria-disabled');
        submitButton.classList.remove('loading');
        const spinner = submitButton.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.add('hidden');

        const label = submitButton.querySelector('span');
        const labelUpdated = submitButtonUpdated.querySelector('span');
        if (label && labelUpdated) label.innerHTML = labelUpdated.innerHTML;
      }

      const productFormId = `product-form-${domSectionId}`;
      const productFormIdUpdated = `product-form-${originalSectionId}`;
      const stickyAtcButton = this.querySelector(`.sticky-atc__button button[form="${productFormId}"]`);
      const stickyAtcButtonUpdated = html.querySelector(`.sticky-atc__button button[form="${productFormIdUpdated}"]`);
      if (stickyAtcButton && stickyAtcButtonUpdated) {
        if (stickyAtcButtonUpdated.hasAttribute('disabled')) stickyAtcButton.setAttribute('disabled', '');
        else stickyAtcButton.removeAttribute('disabled');

        stickyAtcButton.removeAttribute('aria-disabled');
        stickyAtcButton.classList.remove('loading');
        const spinner = stickyAtcButton.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.add('hidden');

        const label = stickyAtcButton.querySelector('span');
        const labelUpdated = stickyAtcButtonUpdated.querySelector('span');
        if (label && labelUpdated) label.innerHTML = labelUpdated.innerHTML;
      }
    }

    setUnavailable() {
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton) submitButton.setAttribute('disabled', '');
    }
  }
)};
